module.exports = __webpack_public_path__ + "img/no-pickup.8148ccf4.svg";